import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col gap-2" };
const _hoisted_2 = ["id"];
import { ref, useId, watch } from "vue";
import { useI18n } from "vue-i18n";
import { Drawer, ToggleInput } from "@eudonet/opal";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ValueDisplayDrawer',
    props: {
        modelValue: { type: Boolean },
        title: {},
        displayed: { type: Boolean },
        lock: {}
    },
    emits: ["update:modelValue", "apply", "lockBlocked"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const LOCK_MESSAGE_KEYS = {
            essential: "valueLists.detail.drawer.lock.essential",
            lastDisplayed: "valueLists.detail.drawer.lock.lastDisplayed",
            deprecated: "valueLists.detail.drawer.lock.deprecated",
            essentialChild: "valueLists.detail.drawer.lock.essentialChild",
            parentHidden: "valueLists.detail.drawer.lock.parentHidden",
        };
        const { t } = useI18n();
        const lockId = useId();
        const draft = ref(props.displayed);
        watch(() => [props.modelValue, props.displayed], ([open]) => {
            if (open)
                draft.value = props.displayed;
        });
        // CONSTRAINT: one gesture can reach this wrapper as two clicks in the same task: the card forwards
        // its click to the switch, and a label click is re-dispatched on it. Report once per task.
        let reportedThisTask = false;
        function reportLockedAttempt() {
            if (!props.lock || reportedThisTask)
                return;
            reportedThisTask = true;
            setTimeout(() => (reportedThisTask = false));
            emit("lockBlocked", props.lock);
        }
        function apply() {
            emit("apply", draft.value);
            emit("update:modelValue", false);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Drawer), {
                "model-value": __props.modelValue,
                title: __props.title,
                subtitle: _unref(t)('valueLists.detail.drawer.subtitle'),
                "aria-close-label": _unref(t)('common.close'),
                "actions-layout": "stacked",
                actions: [
                    {
                        id: 'apply',
                        label: _unref(t)('valueLists.detail.drawer.apply'),
                        testId: 'value-display-drawer-apply',
                        disabled: draft.value === __props.displayed,
                        onClick: apply,
                    },
                    {
                        id: 'cancel',
                        label: _unref(t)('form.cancel'),
                        variant: 'secondary',
                        testId: 'value-display-drawer-cancel',
                        onClick: () => emit('update:modelValue', false),
                    },
                ],
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (emit('update:modelValue', $event)))
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", {
                            "data-testid": "value-display-drawer-switch",
                            onClickCapture: reportLockedAttempt
                        }, [
                            _createVNode(_unref(ToggleInput), {
                                "model-value": draft.value,
                                type: "title-toggle",
                                label: _unref(t)('valueLists.detail.drawer.display'),
                                description: _unref(t)('valueLists.detail.drawer.displayDescription'),
                                "aria-disabled": __props.lock !== null,
                                "aria-describedby": __props.lock ? _unref(lockId) : undefined,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (draft.value = $event))
                            }, null, 8 /* PROPS */, ["model-value", "label", "description", "aria-disabled", "aria-describedby"])
                        ], 32 /* NEED_HYDRATION */),
                        _createElementVNode("p", {
                            id: _unref(lockId),
                            "aria-live": "polite",
                            class: "flex items-start gap-2 text-sm text-(--colors-text-body-subtle) dark:text-(--colors-text-white-default)",
                            "data-testid": "value-display-drawer-lock"
                        }, [
                            (__props.lock)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[2] || (_cache[2] = _createElementVNode("i", {
                                        class: "ri-lock-line",
                                        "aria-hidden": "true"
                                    }, null, -1 /* CACHED */)),
                                    _createElementVNode("span", null, _toDisplayString(_unref(t)(LOCK_MESSAGE_KEYS[__props.lock])), 1 /* TEXT */)
                                ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true)
                        ], 8 /* PROPS */, _hoisted_2)
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["model-value", "title", "subtitle", "aria-close-label", "actions"]));
        };
    }
});
